import { AlertTriangle, CheckCircle2, CircleDashed, MinusCircle, XCircle } from 'lucide-react';
import type { CalibrationItem } from '../config/calibration';

const labels = {
  checking: 'Checking',
  passed: 'Passed',
  needs_attention: 'Needs attention',
  failed: 'Failed',
  not_required: 'Not required'
} as const;

export function CalibrationChecklist({ items, title = 'System Check' }: { items: CalibrationItem[]; title?: string }) {
  return (
    <section aria-labelledby="calibration-heading">
      <h2 id="calibration-heading" className="font-semibold">{title}</h2>
      <ul className="mt-3 divide-y divide-white/10" aria-live="polite" aria-atomic="true">
        {items.map((item) => {
          const Icon = item.state === 'passed' ? CheckCircle2 : item.state === 'failed' ? XCircle : item.state === 'needs_attention' ? AlertTriangle : item.state === 'not_required' ? MinusCircle : CircleDashed;
          const tone = item.state === 'passed' ? 'text-emerald-400' : item.state === 'failed' ? 'text-red-300' : item.state === 'needs_attention' ? 'text-amber-300' : 'text-slate-400';
          return (
            <li key={item.key} className="py-3">
              <div className="flex items-center justify-between gap-3 text-sm">
                <span className="font-medium">{item.label}</span>
                <span className={`flex items-center gap-2 ${tone}`}><Icon className="h-4 w-4" />{labels[item.state]}</span>
              </div>
              {(item.state === 'failed' || item.state === 'needs_attention') ? <p className="mt-1 text-xs text-slate-300">{item.guidance}</p> : null}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
